
import { Vue, Component, Watch } from 'vue-property-decorator';
import {
  Form,
  FormItem,
  Input,
  InputNumber,
  Cascader,
} from 'element-ui';
import { ISearchForm } from '@/types/course.d';
import api from '@/api/question';

@Component({
  components: {
    Form,
    FormItem,
    Input,
    InputNumber,
    Cascader,
  },
})
export default class SearchForm extends Vue {
  private form: ISearchForm = {
    title: '',
    version: '',
    tid: [],
    standardNumber: '0',
  };

  private courseTypes: { value: string, label: string, children: any }[] = [];

  public $refs!: {
    form: Form,
  };

  mounted() {
    api.getCourseType().then((res: any) => {
      res.forEach((elem: any, index: number) => {
        this.courseTypes.push({ value: elem.id, label: elem.label, children: [] });
        elem.children.forEach((element: any) => {
          this.courseTypes[index].children.push({ value: element.id, label: element.label });
        });
      });
    });
  }

  /**
   * @author liangyongmou
   * @description  接收普通搜索的值
   * @param { searchValue } 普通搜索的值
   */
  setTitle(searchValue: string) {
    this.form.title = searchValue;
  }

  /**
   * @author liangyongmou
   * @desc 获取查询数据
   */
  getFormData() {
    return this.form;
  }

  /**
   * @author liangyongmou
   * @desc 清空事件
   */
  handleClear() {
    this.$refs.form.resetFields();
  }
}
